// import { ChevronRight } from "lucide-react";
// import { useState } from "react"; // <-- missing in your code
// import "./loopview.css";

// const LoopSixbody = ({ data, setActivityText }) => {
//     const [activity, setActivity] = useState(false);

//     const handleClickActivity = () => {
//         setActivity(true);
//     };

//     const handleActivityChange = (e) => {
//         setActivityText(e.target.value);
//     };

//     return (
//         <div>
//             {/* Multi-line title support */}
//             <h5 className="title">
//                 {data.TitleName.split('\n').map((line, index) => (
//                     <div key={index} className="title-line">{line}</div>
//                 ))}
//             </h5>

//             {/* Conditional rendering based on activity */}
//             {activity ? (
//                 <>
//                     {data.bodytext1 && <p className="bodytext1">{data.bodytext1}</p>}
//                     {data.bodytext2 && <p className="bodytext1">Write your response below to get instant feedback from your AI tutor.</p>}
//                     <textarea
//                         onChange={handleActivityChange}
//                         placeholder="Type your answer..."
//                         className="activity-input"
//                     />


//                 </>
//             ) : (
//                 <>
//                     {data.bodytext1 && <p className="bodytext1">{data.bodytext1}</p>}
//                     {data.bodytext2 && <p className="bodytext1">{data.bodytext2}</p>}
//                     {data.bodytext3 && <p className="bodytext2 mt-2">{data.bodytext3}</p>}
//                 </>
//             )}

//             {/* Buttons */}
//             <div className="skills-container mt-4">
//                 {/* {!activity && (
//                     <span onClick={handleClickActivity} className="tag btn">
//                         Start Activity <ChevronRight className="inline size-5" />
//                     </span>
//                 )} */}
//                 <span onClick={handleClickActivity} className="tag btn">
//                     Get Feedback from Alice <ChevronRight className="inline size-5" />
//                 </span>
//             </div>
//         </div>
//     );









    
// };

// export default LoopSixbody;


// import { ChevronRight } from "lucide-react";
// import { useState } from "react";
// import "./loopview.css";

// const LoopSixbody = ({ data, setActivityText, tutorName }) => {
//     const [activity, setActivity] = useState(false);

//     const handleClickActivity = () => {
//         setActivity(true);
//     };

//     const handleActivityChange = (e) => {
//         setActivityText(e.target.value);
//     };

//     return (
//         <div>
//             {/* Multi-line title support */}
//             <h5 className="title">
//                 {data.TitleName.split('\n').map((line, index) => (
//                     <div key={index} className="title-line">{line}</div>
//                 ))}
//             </h5>

//             {/* Conditional rendering based on activity */}
//             {activity ? (
//                 <>
//                     {data.bodytext1 && <p className="bodytext1">{data.bodytext1}</p>}
//                     {data.bodytext2 && <p className="bodytext1">Write your response below to get instant feedback from your AI tutor.</p>}
//                     <textarea
//                         onChange={handleActivityChange}
//                         placeholder="Type your answer..."
//                         className="activity-input"
//                     />
//                 </>
//             ) : (
//                 <>
//                     {data.bodytext1 && <p className="bodytext1">{data.bodytext1}</p>}
//                     {data.bodytext2 && <p className="bodytext1">{data.bodytext2}</p>}
//                     {data.bodytext3 && <p className="bodytext2 mt-2">{data.bodytext3}</p>}
//                 </>
//             )}

//             {/* Buttons */}
//             <div className="skills-container mt-4">
//                 <span onClick={handleClickActivity} className="tag btn">
//                     Get Feedback from {tutorName} <ChevronRight className="inline size-5" />
//                 </span>
//             </div>
//         </div>
//     );
// };

// export default LoopSixbody;

import { useState } from "react";
import { ChevronRight } from "lucide-react";
import BotIntegration from "../BotIntegration/BotIntegration"; // import your chat modal component
import "./loopview.css";

const LoopSixbody = ({ data, tutorName, selectedTutorRef, onToggleChat }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [botId, setBotId] = useState("");

  const handleFeedbackClick = () => {
    // ✅ Prefer the selected tutor’s bot_id if available
    const assignedBotId =
      selectedTutorRef?.current?.bot_id ||
      selectedTutorRef?.current?.botdata?.bot_id ||
      data.bot_id ||
      "defaultBotId";

    console.log("🟢 Chat opening with bot ID:", assignedBotId);
    console.log("🧑‍🏫 Tutor:", selectedTutorRef?.current?.fullName || selectedTutorRef?.current?.name || "Unknown Tutor");

    setBotId(assignedBotId);
    onToggleChat?.(assignedBotId);
    setIsChatOpen(prev => !prev);
  };

  return (
    <div>
      {/* Multi-line title */}
      <h5 className="title">
        {data.TitleName.split("\n").map((line, index) => (
          <div key={index} className="title-line">
            {line}
          </div>
        ))}
      </h5>

      {/* Body texts */}
      {data.bodytext1 && <p className="bodytext1">{data.bodytext1}</p>}
      {data.bodytext2 && <p className="bodytext1">{data.bodytext2}</p>}
      {data.bodytext3 && <p className="bodytext2 mt-2">{data.bodytext3}</p>}

      {/* Button */}
      <div className="skills-container mt-4">
        <span className="tag btn" onClick={handleFeedbackClick}>
          {isChatOpen
            ? `Close Feedback from ${tutorName}`
            : `Get Feedback from ${tutorName}`}
          <ChevronRight className="inline size-5" />
        </span>
      </div>

      {/* Chat modal */}
      {isChatOpen && (
        <BotIntegration botId={botId} userId="currentUser@example.com" />
      )}
    </div>
  );
};

export default LoopSixbody;